(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('MaterialFileIbqDialogController', MaterialFileIbqDialogController);

    MaterialFileIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'MaterialFile', 'Material', 'PortalRole', 'Copyright'];

    function MaterialFileIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, MaterialFile, Material, PortalRole, Copyright) {
        var vm = this;

        vm.materialFile = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.materials = Material.query();
        vm.portalroles = PortalRole.query();
        vm.copyrights = Copyright.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.materialFile.id !== null) {
                MaterialFile.update(vm.materialFile, onSaveSuccess, onSaveError);
            } else {
                MaterialFile.save(vm.materialFile, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:materialFileUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setMatlFile = function ($file, materialFile) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        materialFile.matlFile = base64Data;
                        materialFile.matlFileContentType = $file.type;
                        materialFile.partPath=$file.name;
                    });
                });
            }
        };

    }
})();
